var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { QualityCheckUrl } from "@adapters/infrastructures/urlConfig/Markets/aifPmsURL";
import { AssignToSelfMapper, DeleteDocsMapper, DocumentDetailsMapper, DocumentListMapper, DownloadPendingTransactionMapper, FolioDetailsMapper, ModifyTransactionMapper, PendingCountMapper, PendingTransactionByIdMapper, PendingTransactionsMapper, UpdateApproveRejectStatusMapper, UploadDocsMapper, } from "@domains/features/Markets/AIF-PMS/mapper/QualityCheckMapper";
var QualityCheckRepository = /** @class */ (function () {
    function QualityCheckRepository(http) {
        this.http = http;
    }
    //
    QualityCheckRepository.prototype.pendingTransactions = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(QualityCheckUrl.pendingTransactions);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, PendingTransactionsMapper(data)];
                }
            });
        });
    };
    QualityCheckRepository.prototype.pendingTransactionsById = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(QualityCheckUrl.pendingTransactionById);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, PendingTransactionByIdMapper(data)];
                }
            });
        });
    };
    QualityCheckRepository.prototype.assignToSelf = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(QualityCheckUrl.assignToSelf);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, AssignToSelfMapper(data)];
                }
            });
        });
    };
    QualityCheckRepository.prototype.updateApproveRejectStatus = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(QualityCheckUrl.updateApproveRejectStatus);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, UpdateApproveRejectStatusMapper(data)];
                }
            });
        });
    };
    QualityCheckRepository.prototype.documentList = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(QualityCheckUrl.documentList);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, DocumentListMapper(data)];
                }
            });
        });
    };
    QualityCheckRepository.prototype.documentDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(QualityCheckUrl.documentDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, DocumentDetailsMapper(data)];
                }
            });
        });
    };
    QualityCheckRepository.prototype.modifyTransaction = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(QualityCheckUrl.modifyTransaction);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, ModifyTransactionMapper(data)];
                }
            });
        });
    };
    QualityCheckRepository.prototype.folioDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(QualityCheckUrl.folioDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, FolioDetailsMapper(data)];
                }
            });
        });
    };
    QualityCheckRepository.prototype.pendingCount = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(QualityCheckUrl.pendingCount);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, PendingCountMapper(data)];
                }
            });
        });
    };
    QualityCheckRepository.prototype.downloadPendingTransaction = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(QualityCheckUrl.downloadPendingTransaction);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, DownloadPendingTransactionMapper(data)];
                }
            });
        });
    };
    QualityCheckRepository.prototype.uploadDocs = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(QualityCheckUrl.uploadDocs);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, UploadDocsMapper(data)];
                }
            });
        });
    };
    QualityCheckRepository.prototype.deleteDocs = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(QualityCheckUrl.deleteDocs);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                avoidAppID: true,
                                body: req,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, DeleteDocsMapper(data)];
                }
            });
        });
    };
    return QualityCheckRepository;
}());
export default QualityCheckRepository;
